import LoadingComponent from './Loading'

const UserDropdownAsync = () => ({
  component: import(/* webpackChunkName: "group-level-1" */ './UserDropdown.vue'),
  loading: LoadingComponent,
  // Delay before showing the loading component. Default: 200ms.
  delay: 20,
  // The error component will be displayed if a timeout is
  // provided and exceeded. Default: Infinity.
})

export {UserDropdownAsync}
